import { GetColumnClassName } from '@helpers/Components/getColumnClassName';
import React from 'react';
import { useSelector } from 'react-redux';
import { useMaster } from '../../../utility/hooks/useMaster';
import { CardInterpreter } from './CardInterpreter';
import { DocumentationInterpreter } from './DocumentationInterpreter';
import { RepeaterInterpreter } from './RepeaterInterpreter';
import { ListInterpreter } from './ListInterpreter';

export const BlockInterpreter = ({ block, cardStyle = 'card' }) => {
  const componentList = {
    CardInterpreter,
    RepeaterInterpreter,
    DocumentationInterpreter,
    ListInterpreter,
  };

  const {
    title,
    subTitle,
    col,
    interpreter = 'CardInterpreter',
    exceptions = [],
    master = null,
    collection = [],
    base = {},
  } = block;

  const Component = componentList[interpreter];
  const { form } = useSelector((state) => state);
  const { validateMaster } = useMaster(collection, form);

  return (
    <div
      className={`${GetColumnClassName(col)} ${
        !!master && validateMaster(master) === false ? 'd-none' : 'd-block'
      }`}
    >
      <div className={`${cardStyle}`}>
        <div className="card-header pb-0 pt-1 mb-0 d-flex">
          {title && (
            <div className="col-12">
              {' '}
              <h4>{title}</h4>
            </div>
          )}
        </div>
        {subTitle && (
          <div className="col-12">
            {' '}
            <h5 className="border-bottom">{subTitle}</h5>
          </div>
        )}
        <div className={`card-body row pt-0`}>
          <Component
            {...block}
            {...base}
            exceptions={exceptions}
            master={master}
            collection={collection}
          />
        </div>
      </div>
    </div>
  );
};
